import React from 'react';
import { DataTable, SectionHeader, StatusPill } from '../components';

export function EmailsPage({ rows }) {
  const sent = (rows.emails || []).reduce((s, e) => s + (e.sent || 0), 0);
  const opens = (rows.emails || []).reduce((s, e) => s + (e.opens || 0), 0);
  const openRate = sent > 0 ? ((opens / sent) * 100).toFixed(1) : '0.0';
  return (
    <div>
      <SectionHeader
        title="Emails"
        subtitle={`${rows.emails?.length || 0} campaigns · ${sent.toLocaleString('fr-FR')} sent · ${openRate}% open rate`}
      />
      <DataTable
        testid="dash-emails-table"
        rows={rows.emails}
        emptyText="No campaigns yet."
        columns={[
          { key: 'subject',  label: 'Subject' },
          { key: 'audience', label: 'Audience', nowrap: true },
          { key: 'sent',     label: 'Sent',     nowrap: true,
            render: r => Number(r.sent || 0).toLocaleString('fr-FR') },
          { key: 'opens',    label: 'Opens',    nowrap: true,
            render: r => Number(r.opens || 0).toLocaleString('fr-FR') },
          { key: 'clicks',   label: 'Clicks',   nowrap: true },
          { key: 'status',   label: 'Status',
            render: r => <StatusPill value={r.status} /> },
          { key: 'sent_at',  label: 'Sent at',  nowrap: true,
            render: r => (r.sent_at || '').slice(0, 10) || '—' },
        ]}
      />
    </div>
  );
}
